import { render } from "./user-type-card.template.html?vue&type=template&id=050bd309&scoped=true"
import script from "./UserTypeCard.vue?vue&type=script&lang=ts"
export * from "./UserTypeCard.vue?vue&type=script&lang=ts"

import "./UserTypeCard.vue?vue&type=style&index=0&id=050bd309&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-050bd309"

export default script